module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal__user__settings__notifications text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['user_settings']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), (_vm.isSMSActive) ? _c('div', {
    staticClass: "d-input-group__group"
  }, [_c('div', {
    staticClass: "d-input-group input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['mobile_number']))]), _vm._v(" "), _c('div', {
    staticClass: "flex-group",
    class: {
      'animated shake': _vm.isAnimatePhone
    }
  }, [_c('div', {
    staticClass: "flag__input-lookalike active-country"
  }, [_c('img', {
    staticClass: "country-flag",
    attrs: {
      "src": _vm.activeCountry.flag
    }
  }), _vm._v("+" + _vm._s(_vm.activeCountry.countryCode) + "\n              "), _c('DDropdown', [_c('span', {
    staticClass: "icon-arrow-down5",
    attrs: {
      "slot": "d-dropdown__icon"
    },
    slot: "d-dropdown__icon"
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.countries), function(country) {
    return _c('li', {
      key: country.countryCode,
      staticClass: "country-select__item",
      on: {
        "click": function($event) {
          return _vm.setActiveCountry(country)
        }
      }
    }, [_c('div', {
      staticClass: "country-select__item__name"
    }, [_c('img', {
      staticClass: "country-flag",
      attrs: {
        "src": country.flag
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(country.name))])]), _vm._v("\n                    + " + _vm._s(country.countryCode) + "\n                  ")])
  }), 0)])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    ref: "input_phone",
    staticClass: "d-input",
    class: {
      'input--error': !_vm.isPhoneValid
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "keyup": function($event) {
        return _vm.onPhoneKeyup($event.target.value)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isPhoneValid) ? _c('span', {
    staticClass: "error-text marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['number_must_be_8_digits']))]) : _vm._e()]), _vm._v(" "), (_vm.user.unconfirmed_phone) ? _c('div', {
    staticClass: "d-label d-pill",
    class: {
      'animated shake': _vm.isAnimatePhoneUnconfirmed
    }
  }, [_c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['awaiting_approval']) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.hideSMSToggle && (_vm.user.v_phone_setting === 'active' || _vm.user.v_phone_setting === 'deactivated')) ? _c('div', {
    staticClass: "d-input-group marg-2-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['receive_sms']))]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group__toggle",
    on: {
      "click": function($event) {
        return _vm.toggleSetting('phone')
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.receiveSMS
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
    staticClass: "d-input-group__group"
  }, [_c('div', {
    staticClass: "d-input-group input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "d-input",
    class: {
      'input--error': !_vm.isEmailValid
    },
    staticStyle: {
      "height": "40px"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        return _vm.onEmailKeyup($event.target.value)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isEmailValid) ? _c('span', {
    staticClass: "error-text marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['use_a_valid_email']))]) : _vm._e()]), _vm._v(" "), (!_vm.hideEmailToggle && (_vm.user.v_email_setting === 'active' || _vm.user.v_email_setting === 'deactivated')) ? _c('div', {
    staticClass: "d-input-group marg-2-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['receive_email']))]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group__toggle",
    on: {
      "click": function($event) {
        _vm.receiveEmails = !_vm.receiveEmails
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.receiveEmails
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-input-group d-input-group__submit"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary",
    class: [{
      ' bttn--loading': _vm.isSubmitting
    }, {
      'bttn-primary--disabled': !this.isEmailValid || !this.isPhoneValid
    }],
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43485a14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/SendMessagesUserSetting.vue
// module id = 1609
// module chunks = 1